import { spread } from 'lodash-es';
import React, { Fragment, useRef, useState, useEffect, useReducer, Children } from 'react';
import { connect } from 'react-redux';
import { nextSpread, previousSpread, getPage, goToPage } from '../Actions/OnlineCatalog.action';
import { translate } from '../../Services/translation';

function getWindowDimensions() {
    const { innerWidth: width } = window;
    return {
        width
    };
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions.width;
}

const OnlineCatalogViewer = props => {
    const { rightPageHtml, leftPageHtml, nextPage, previousPage, goToPage, currentPage, getPage, spreadWidthLimit, tableOfContents, pages, isRightBrowse, pageFlipClass } = props;
    const magnificationStep = 10;
    const [pageNumber, setPageNumber] = useState(currentPage);
    const [menuActive, setMenuActive] = useState(false);
    const [magnification, setMagnification] = useState(100);
    const onChangeHandler = event => {
        getPage(event.target.value, spreadSize, event);
        setPageNumber(event.target.value);
    };
    const tableOfContentRef = useRef();
    const offCanvasMenu = useRef();
    useEffect(() => {
        if (currentPage) {
            setPageNumber(currentPage);
        }
    }, [currentPage]);
    
    const goToSelectedPage = (spreadSize, thePageNo = 0) => {
        const pageNo = thePageNo || parseInt(tableOfContentRef.current.value);
        goToPage(spreadSize, pageNo);
    }

    const magnify = (isIncrease) => {
        let newMagnification = magnification;
        if (isIncrease) {
            if (magnification > (200 - magnificationStep))
                return;
            newMagnification = magnification + magnificationStep;
        } else {
            if (magnification < (10 + magnificationStep))
                return;
            newMagnification = magnification - magnificationStep;
        }
        setMagnification(newMagnification);
        const containerEl = document.getElementById("onlineCatalogContainer");
        if (containerEl) {
            containerEl.setAttribute("data-magnification", newMagnification);
        }
    }

    //const setPageNumber = () => {
    //    return window.matchMedia('(hover: hover)').matches //true or false
    //}
    //useEffect(() => {
    //    setPageNumber(currentPage);
    //});
    let spreadSize = useWindowDimensions() > spreadWidthLimit ? 2 : 1;
    let spreadClass = spreadSize == 1 ? '' : 'medium-6';
    let pageTotal = pages.length;
    if (pageTotal !== 0 && (pageTotal % 2 !== 0)) {
        pageTotal++;
    }
    return (
        <Fragment>
            <div className={`online-catalog-container online-catalog-container__pagination row ${spreadSize === 2 ? 'online-catalog-container__page-size--double' : ''}`}>

                <section className={`pagenation-items`}>
                    <span><button className="online-catalog-container__button-page-pagenation--prev" onClick={() => previousPage(spreadSize)}><i className="fas fa-angle-left"></i></button></span>
                    <span>Sida</span>
                    <input type="number" max-value="100" min-value="1" value={pageNumber} onChange={onChangeHandler} />
                    <span> av {pageTotal} </span>
                    <span><button className="online-catalog-container__button-page-pagenation--next" onClick={() => nextPage(spreadSize)}><i className="fas fa-angle-right"></i></button></span>

                    {spreadSize === 2 &&
                        <div className="online-catalog__magnification">
                            <section className="online-catalog__magnification-container">
                                <button className="online-catalog__magnification--decrease" onClick={() => magnify(false)}><i className="fas fa-search-minus"></i></button>
                                <span>{magnification}%</span>
                                <button className="online-catalog__magnification--increase" onClick={() => magnify(true)}><i className="fas fa-search-plus"></i></button>
                            </section>
                        </div>
                    }
                </section>
            </div>
            {spreadSize === 1 ? (
                <div className="online-catalog-container row">
                    <div className="small-10 columns">
                        <section className="online-catalog-container__table">
                            <h5>{translate('common.onlinecatalog.tableofcontent')}</h5>
                            <form>
                                <select name="tableOfContents" ref={tableOfContentRef} onChange={() => goToSelectedPage(spreadSize)} >
                                    {tableOfContents.map((header, index) => {
                                        return (
                                            <Fragment key={'container' + index}>
                                                <option key={index} value={header.pageNumber}>{header.headerText}</option>
                                                {header.children.map((subheader, i) => {
                                                    return (
                                                        <option key={index + '_' + i} value={subheader.pageNumber}>{subheader.headerText}</option>
                                                    );
                                                })}
                                            </Fragment>
                                        );
                                    })}
                                </select>
                            </form>
                        </section>
                    </div>
                </div>) :
                (
                    <aside ref={offCanvasMenu} className={`${menuActive ? 'active' : ''}`}>
                        <div className="online-catalog__hamburger" onClick={() => setMenuActive(!menuActive)}>
                            <button className="nav__hamburger-icon" title={translate('common.onlinecatalog.menu')}>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                            <span className="nav__hamburger-icon-title">{translate('common.onlinecatalog.menu')}</span>
                        </div>
                        <nav className="subnav" role="navigation">
                            <h5>{translate('common.onlinecatalog.tableofcontent')}</h5>
                            <ul className="subnav__list ">
                                {tableOfContents.map((header, index) => {
                                    return (
                                        <Fragment key={'offCanvasContainer' + index}>
                                            <li key={'offCanvas' + index} onClick={() => goToSelectedPage(spreadSize, header.pageNumber)}>{header.headerText} <span>({translate('common.onlinecatalog.page')} {header.pageNumber})</span></li>
                                            {header.children.map((subheader, i) => {
                                                return (
                                                    <li className="subnav__sub-header" key={'offCanvas' + index + '_' + i} onClick={() => goToSelectedPage(spreadSize, subheader.pageNumber)}>{subheader.headerText.trim()} <span>({translate('common.onlinecatalog.page')} {subheader.pageNumber})</span></li>
                                                );
                                            })}
                                        </Fragment>
                                    );
                                })}
                            </ul>
                        </nav>
                    </aside>
                )
            }
            <div className={`online-catalog-container online-catalog-container__content row ${pageFlipClass}`} id="onlineCatalogContainer">
                <button className="online-catalog-container__button-page online-catalog-container__button-page--left" onClick={() => previousPage(spreadSize)}><i className="fas fa-angle-left"></i></button>
                <div className="online-catalog-container__content-pages row">
                    <div className={`online-catalog-container__page-left small-12 ${spreadClass} columns`}>
                        <div key={currentPage} dangerouslySetInnerHTML={{ __html: leftPageHtml }}></div>
                        <div className="page-number">{currentPage}</div>
                    </div>
                    {spreadSize === 2 &&
                        <div className="online-catalog-container__page-right medium-6 columns">
                            <div key={currentPage + 1} dangerouslySetInnerHTML={{ __html: rightPageHtml }}></div>
                            <div className="page-number">{currentPage + 1}</div>
                        </div>
                    }
                </div>
                <button className="online-catalog-container__button-page online-catalog-container__button-page--right" onClick={() => nextPage(spreadSize)}><i className="fas fa-angle-right"></i></button>
            </div>
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        rightPageHtml: state.onlineCatalog.rightPageHtml,
        leftPageHtml: state.onlineCatalog.leftPageHtml,
        pages: state.onlineCatalog.pages,
        currentPage: state.onlineCatalog.currentPage,
        spreadWidthLimit: state.onlineCatalog.spreadWidthLimit,
        tableOfContents: state.onlineCatalog.tableOfContents,
        isRightBrowse: state.onlineCatalog.isRightBrowse,
        pageFlipClass: state.onlineCatalog.pageFlipClass,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        previousPage: (spreadSize) => dispatch(previousSpread(spreadSize)),
        nextPage: (spreadSize) => dispatch(nextSpread(spreadSize)),
        getPage: (pageNumber, spreadSize, event) => dispatch(getPage(pageNumber, spreadSize, event)),
        goToPage: (spreadSize, pageNumber) => dispatch(goToPage(spreadSize, pageNumber)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineCatalogViewer);